<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>管理员模块</el-breadcrumb-item>
            <el-breadcrumb-item>企业列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="6">
        <div class="grid-content">
          公司名称:
          <el-input v-model="name"
                    style="width: unset;"
                    placeholder="请输入公司名称"></el-input>
        </div>

      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          负责人名称:
          <el-input v-model="contacts"
                    style="width: unset;"
                    placeholder="请输入负责人名称"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <!-- <div class="grid-content">
          时间：
          <el-date-picker
            v-model="addDate"
            type="daterange"
            style="width: 220px;"
            format="yyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div> -->
        <div class="grid-content">
          负责人电话:
          <el-input v-model="tel"
                    style="width: unset;"
                    placeholder="请输入负责人电话"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <el-button type="primary"
                     size="small"
                     @click="quset">查询</el-button>
          <el-button type="primary"
                     @click="administratorsAdd"
                     size="small">新增</el-button>
        </div>
      </el-col>
    </el-row>
    <el-table :data="tableData"
              border
              style="width: 95%">
      <el-table-column prop="name"
                       label="企业名称"
                       width="100"></el-table-column>
      <el-table-column prop="contacts"
                       label="负责人名称"
                       width="100"></el-table-column>
      <el-table-column prop="tel"
                       label="负责人电话"
                       width="120"></el-table-column>
      <el-table-column prop="userName"
                       label="登陆账号"
                       width="100"></el-table-column>
      <el-table-column prop="state"
                       label="状态"
                       width="50"></el-table-column>
      <el-table-column prop="state"
                       label="状态"
                       width="60">
        <template slot-scope="scope">
          {{scope.row.priceHide?"隐藏":"不隐藏"}}
        </template>
      </el-table-column>
      <el-table-column prop="employeesLimit"
                       label="分配员工"
                       width="100"></el-table-column>
      <el-table-column prop="validity"
                       label="到期时间"
                       width="100"></el-table-column>
      <el-table-column prop="address"
                       label="地址"></el-table-column>
      <el-table-column fixed="right"
                       label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="goDetails(scope.row)"
                     size="small">详情</el-button>
          <!-- <el-button type="text" size="small">添加人数</el-button> -->
          <!-- <el-button type="text" size="small">修改密码</el-button> -->
          <el-button type="text"
                     size="small"
                     @click="addEmployeesLimit(scope.row)">添加人数</el-button>
          <el-button type="text"
                     size="small"
                     @click="delay(scope.row)">延期</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="grid-content"
                   background
                   @current-change="handleCurrentChange"
                   layout="total, prev, pager, next"
                   :total="totalCount"
                   :page-size="pageSize"
                   :page-count="pageTotal"></el-pagination>

    <div>
      <el-dialog title="添加人数"
                 :visible.sync="addEmployeesLimitShow"
                 center
                 ref="ruleForm"
                 label-width="40px">
        <el-form>
          <el-form-item label="添加人数:">
            <el-input v-model="addEmployeesLimitNumber"
                      placeholder="请输入添加人数"
                      type="number"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addEmployeesLimitBack">取 消</el-button>
          <el-button type="primary"
                     @click="addEmployeesLimitOK">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="延期"
                 :visible.sync="delayShow"
                 center
                 ref="ruleForm"
                 label-width="40px">
        <el-form>
          <el-form-item label="延期时间:">
            <el-select v-model="value"
                       style="width:200px"
                       placeholder="请选择"
                       @change="getExpirationDate">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            延期至 <span>{{etime}}</span>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="delayShowBack">取 消</el-button>
          <el-button type="primary"
                     @click="delayShowOK">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { enterpriseSel, enterpriseMod } from "@/api/enterprise";
import { getEnterpriseStates } from "@/util/enum";
import moment from "moment";
export default {
  data () {
    return {
      time: "",
      number: "",
      name: "",
      contacts: "",
      tel: "",
      addDate: "",
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: [],
      addEmployeesLimitShow: false,
      updata: "",
      addEmployeesLimitNumber: "",
      delayShow: false,
      value: 1,
      etime: "",
      options: [
        {
          value: 1,
          label: "一个月"
        },
        {
          value: 2,
          label: "两个月"
        },
        {
          value: 3,
          label: "三个月"
        },
        {
          value: 4,
          label: "四个月"
        },
        {
          value: 5,
          label: "五个月"
        },
        {
          value: 6,
          label: "半年"
        },
        {
          value: 12,
          label: "一年"
        },
        {
          value: 24,
          label: "两年"
        },
        {
          value: 36,
          label: "三年"
        }
      ]
    };
  },
  mounted () {
    this.getEnterpriseList();
  },
  methods: {
    goDetails (row) {
      this.$router.push({ path: "details", query: { id: row.id } });
      //this.$router.push("/home/administrators/details");
    },
    quset () {
      this.pageNum = 1;
      this.getEnterpriseList();
    },
    addEmployeesLimit (row) {
      this.updata = row;
      this.addEmployeesLimitShow = true;
    },
    delay (row) {
      this.updata = row;
      this.value = 1;
      this.delayShow = true;
      this.getExpirationDate(this.value);
    },
    administratorsAdd () {
      this.$router.push({ path: "add", query: {} });
    },
    handleCurrentChange (e) {
      this.pageNum = e;
      this.getEnterpriseList();
    },
    addEmployeesLimitBack () {
      this.updata = "";
      this.addEmployeesLimitShow = false;
    },
    delayShowBack () {
      this.updata = "";
      this.delayShow = false;
    },
    getExpirationDate (value) {
      const s = this.updata.validity.split("-");
      const yy = parseInt(s[0]);
      const mm = parseInt(s[1]) - 1;
      const dd = parseInt(s[2]);
      const dt = new Date(yy, mm, dd);
      dt.setMonth(dt.getMonth() + value);
      this.etime = moment(dt).format("YYYY-MM-DD");
    },
    delayShowOK () {
      const params = {
        id: this.updata.id,
        name: this.updata.name,
        contacts: this.updata.contacts,
        tel: this.updata.tel,
        validity: this.etime,
      };
      enterpriseMod(params).then(() => {
        this.$message({
          type: "success",
          message: "延期成功!"
        });
        this.delayShowBack()
        this.quset()
      }).catch(err => {
        console.log(err);
      });
    },
    addEmployeesLimitOK () {
      if (this.addEmployeesLimitNumber != "" && this.addEmployeesLimitNumber > 0) {
        const params = {
          id: this.updata.id,
          name: this.updata.name,
          contacts: this.updata.contacts,
          tel: this.updata.tel,
          employeesLimit: parseInt(this.updata.employeesLimit) + parseInt(this.addEmployeesLimitNumber),
        };
        enterpriseMod(params).then(() => {
          this.$message({
            type: "success",
            message: "添加成功!"
          });
          this.addEmployeesLimitBack()
          this.quset()
        }).catch(err => {
          console.log(err);
        });
      } else {
        this.$message.error("请输入添加人数");
      }
    },
    getEnterpriseList () {
      const params = {
        name: this.name,
        contacts: this.contacts,
        tel: this.tel,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      enterpriseSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = [];
          res.gridData.forEach(element => {
            element.state = getEnterpriseStates(element.states);
            this.tableData.push(element);
          });
        })
        .catch();
    }
  }
};
</script>
